import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { CommaURLSearchParams } from './CommaURLSearchParams';

/** Use comma separated lists in URL Search Params for entries with multiple values */

export const useCommaSearchParams = () => {
  const $ = _c(2);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = new CommaURLSearchParams(searchParams);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const commaSearchParams = t0;
  return commaSearchParams;
};